import { FilterField, FilterInputType } from 'layout/TableLayout/types.d';
import { LOG_EVENT_OPTIONS } from 'constants/logs';

const LOG_LIST_FILTERS: FilterField[] = [
  {
    name: 'createdAt',
    type: FilterInputType.DATE,
    title: 'Дата создания',
  },
  {
    name: 'event',
    type: FilterInputType.AUTOCOMPLETE,
    title: 'Тип',
    options: LOG_EVENT_OPTIONS,
  },
  {
    name: 'status',
    type: FilterInputType.AUTOCOMPLETE,
    title: 'Статус',
    options: LOG_EVENT_OPTIONS,
  },
  {
    name: 'error',
    type: FilterInputType.TEXT,
    title: 'Текст ошибки',
  },
  {
    name: 'competencyMapId',
    type: FilterInputType.TEXT,
    title: 'ID карты компетенций',
  },
  {
    name: 'trialId',
    type: FilterInputType.TEXT,
    title: 'ID навыка',
  },
  {
    name: 'skillId',
    type: FilterInputType.TEXT,
    title: 'ID тестирования',
  },
  {
    name: 'trialAnswerId',
    type: FilterInputType.TEXT,
    title: 'ID ответа',
  },
  {
    name: 'cvCheckId',
    type: FilterInputType.TEXT,
    title: 'ID оценки CV',
  },
];

export default LOG_LIST_FILTERS;
